import { useIntl } from 'react-intl';
import { map } from 'lodash';

import { useTheme } from '@mui/material';
import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import { useGetCandidateDetails } from 'src/pages/CandidatesDetailsPage/api';

import { CandidateTabProps } from '../CandidateShiftsTab';
import { resolveTitle } from 'src/utils/standards';

import messages from './messages';

export default function CandidateJobSettingsTab({ uuid }: CandidateTabProps) {
  const { formatMessage } = useIntl();

  const { data: candidate } = useGetCandidateDetails({
    uuid: uuid,
    enabled: false,
  });

  if (!candidate?.data) return null;

  const { cities, jobTypes, gender, payroll } = candidate.data;

  return (
    <Grid container spacing={5} p={2}>
      <Grid container flexDirection="column" spacing={1}>
        <Typography variant="h4" fontSize={20}>
          {formatMessage(messages.preferredWorkCity)}
        </Typography>
        <Grid container spacing={1.5}>
          {map(cities, (city) => (
            <ChipItem key={city?.id} label={city?.name} />
          ))}
        </Grid>
      </Grid>
      <Grid container flexDirection="column" spacing={1}>
        <Typography variant="h4" fontSize={20}>
          {formatMessage(messages.preferredJobTypes)}
        </Typography>
        <Grid container spacing={1}>
          {map(jobTypes, (jobType) => (
            <ChipItem
              key={jobType?.id}
              label={resolveTitle(
                jobType?.maleTitle,
                jobType?.femaleTitle,
                gender?.code,
              )}
            />
          ))}
        </Grid>
      </Grid>
      <Grid container flexDirection="column" spacing={1}>
        <Typography variant="h4" fontSize={20}>
          {formatMessage(messages.contractType)}
        </Typography>
        <Typography variant="h5" textTransform="capitalize">
          {payroll?.contractType?.code ?? '-'}
        </Typography>
      </Grid>
    </Grid>
  );
}

const ChipItem = ({ label }: { label?: string | null }) => {
  const theme = useTheme();
  return (
    <Box bgcolor={theme.palette.grey[100]} borderRadius={1} p={1}>
      <Typography variant="subtitle1">{label ?? '-'}</Typography>
    </Box>
  );
};
